import React from 'react'
import { useSelector } from 'react-redux'
import { LanguageUtils, StateLabel } from '@pbt/pbt-ui-components'

import CheckboxListFilter, {
  type CheckboxListFilterProps,
} from '~/components/common/filters/CheckboxListFilter'
import { ColorVariant } from '~/constants/colors'
import { TaskStateV2 } from '~/constants/taskConstants'
import { getTaskStates } from '~/store/reducers/constants'

export interface TasksStatusFilterV2Props extends CheckboxListFilterProps {}

const WHITELIST = [
  TaskStateV2.DUE,
  TaskStateV2.OVERDUE,
  TaskStateV2.IN_PROGRESS,
  TaskStateV2.WAITING_FOR_REPLY,
]

const TasksStatusFilterV2 = (props: TasksStatusFilterV2Props) => {
  const TaskStates = useSelector(getTaskStates)

  const items = TaskStates.filter((t) => WHITELIST.includes(t.name)).map(
    (item) => ({
      id: item.id,
      name: item.name,
      component: (
        <StateLabel
          deleted={
            item.color === ColorVariant.IMPORTANT &&
            item.name !== TaskStateV2.WAITING_FOR_REPLY
          }
          disabled={item.color === ColorVariant.DISABLED}
          normal={item.color === ColorVariant.NORMAL}
          success={item.color === ColorVariant.SUCCESS}
          warning={item.name === TaskStateV2.WAITING_FOR_REPLY}
        >
          {LanguageUtils.getTranslatedFieldName(item)}
        </StateLabel>
      ),
    }),
  )

  return (
    <CheckboxListFilter
      arrayFormat
      includeSearch={false}
      items={items}
      {...props}
    />
  )
}

export default TasksStatusFilterV2
